// back compat

import "./joinedPhysicsEngineComponent";
import "./v1/physicsEngineComponent";
